import { useTheme } from 'next-themes';
import {useEffect} from "react";

export default function() {
  const { theme, setTheme } = useTheme();

  useEffect(() => {

  }, [theme]);

  return (
    <>
      {theme === 'dark' || theme === "system" ? (
        <button type="button" role="toggle" aria-label="Switch to Light Mode" onClick={() => setTheme('light')} className="cursor-pointer flex flex-row items-center p-2 hover:bg-gray-100 cursor-pointer">
          <i className="mio">light_mode</i>
        </button>
      ) : (
        <button type="button" role="toggle" aria-label="Switch to Dark Mode" onClick={() => setTheme('dark')} className="cursor-pointer flex flex-row items-center p-2 hover:bg-gray-100 cursor-pointer">
          <i className="mio">dark_mode</i>
        </button>
      )}
    </>
  );
}
